import React, {Component} from "react";
import {Alert, Badge, Button, Modal, Table} from "react-bootstrap";
import {AppContext} from "../../AppContext";
import axios from "axios";
import {PDFViewer} from "react-view-pdf";

/**
 * Karty informacji o kliencie - zakładka w edycji kontrahenta.
 * Materiał poufny, wyłącznie do odczytu: karty powstają w aplikacji mobilnej,
 * tutaj można je tylko przeglądać i pobierać wygenerowane PDF.
 */
class CustomerInfoCards extends Component {

    static contextType = AppContext;

    state = {
        cards: [],
        isLoading: true,
        errorMessage: '',
        showPdfModal: false,
        pdfURL: null,
        currentFileName: ''
    }

    componentDidMount() {
        this.loadCards();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerId !== this.props.customerId) {
            this.loadCards();
        }
    }

    componentWillUnmount() {
        //Zwolnienie blob URL, gdy użytkownik opuści stronę z otwartym podglądem
        if (this.state.pdfURL) {
            window.URL.revokeObjectURL(this.state.pdfURL);
        }
    }

    loadCards = () => {
        if (!this.props.customerId) {
            this.setState({isLoading: false});
            return;
        }
        axios.get(`${this.context.hostname}/api/customer-info-card/findByCustomer/${this.props.customerId}`, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json",
            },
            withCredentials: true
        }).then(res => {
            if (res.status === 200) {
                this.setState({cards: res.data, isLoading: false, errorMessage: ''});
            }
        }).catch((error) => {
            console.log({error});
            this.setState({
                isLoading: false,
                errorMessage: error.response && error.response.status === 403
                    ? 'Brak uprawnień do przeglądania kart informacji o kliencie.'
                    : 'Nie udało się pobrać kart informacji o kliencie.'
            });
        });
    }

    handleShowPdf = (filename) => {
        axios.get(`${this.context.hostname}/api/storage/downloadFile?fileName=${encodeURI(filename)}`, {
            headers: {"X-Requested-With": "XMLHttpRequest"},
            responseType: 'blob',
            withCredentials: true,
        }).then(res => {
            this.setState({
                showPdfModal: true,
                pdfURL: window.URL.createObjectURL(res.data),
                currentFileName: filename
            });
        }).catch((error) => {
            console.log({error});
            this.setState({errorMessage: 'Nie udało się otworzyć pliku PDF.'});
        });
    }

    handleDownloadPdf = (filename) => {
        axios.get(`${this.context.hostname}/api/storage/downloadFile?fileName=${encodeURI(filename)}`, {
            headers: {"X-Requested-With": "XMLHttpRequest"},
            responseType: 'blob',
            withCredentials: true,
        }).then(res => {
            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((error) => {
            console.log({error});
            this.setState({errorMessage: 'Nie udało się pobrać pliku PDF.'});
        });
    }

    handleClosePdfModal = () => {
        if (this.state.pdfURL) {
            window.URL.revokeObjectURL(this.state.pdfURL);
        }
        this.setState({showPdfModal: false, pdfURL: null, currentFileName: ''});
    }

    render() {
        return (
            <div style={{padding: '10px'}}>
                <Alert variant='warning' style={{padding: '5px 10px', fontSize: 13}}>
                    <b>Materiał poufny</b> — wyłącznie do użytku wewnętrznego. Karty tworzone są w aplikacji mobilnej.
                </Alert>

                {this.state.errorMessage !== '' &&
                    <Alert variant='danger' style={{padding: '5px 10px'}}>{this.state.errorMessage}</Alert>
                }

                {this.state.isLoading && <div>Wczytywanie...</div>}

                {!this.state.isLoading && this.state.cards.length === 0 &&
                    <div style={{fontStyle: 'italic'}}>Brak kart informacji dla tego kontrahenta.</div>
                }

                {this.state.cards.length > 0 &&
                    <Table striped bordered hover size="sm" style={{fontSize: 13}}>
                        <thead>
                        <tr>
                            <th>Data</th>
                            <th>Rozmówca</th>
                            <th>Serwisant</th>
                            <th>Wersja</th>
                            <th>Protokoły PDF</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.cards.map(card =>
                            <tr key={card.id}>
                                <td>{card.date}</td>
                                <td>{card.interlocutor}</td>
                                <td>{card.authorName}</td>
                                <td>
                                    {card.version}
                                    {card.version > 1 &&
                                        <Badge bg="warning" text="dark" style={{marginLeft: 5}}>edytowany</Badge>
                                    }
                                </td>
                                <td>
                                    {(card.files || []).length === 0 && <span>—</span>}
                                    {(card.files || []).map(file =>
                                        <div key={file.id} style={{marginBottom: 3}}>
                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                style={{marginRight: 5}}
                                                onClick={() => this.handleShowPdf(file.filename)}>
                                                <i className="bi bi-file-earmark-pdf"/> Podgląd
                                            </Button>
                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                style={{marginRight: 5}}
                                                onClick={() => this.handleDownloadPdf(file.filename)}>
                                                <i className="bi bi-download"/> Pobierz
                                            </Button>
                                            <span style={{fontSize: 11}}>{file.filename}</span>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                }

                <Modal size="xl" show={this.state.showPdfModal} onHide={this.handleClosePdfModal}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{fontSize: 16}}>{this.state.currentFileName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.pdfURL && <PDFViewer url={this.state.pdfURL}/>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClosePdfModal}>Zamknij</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default CustomerInfoCards;
